import Http from "../commons/utils/Http";
import { errorHandling } from "../commons/utils/error";

class NotificationService {

    getOrder(sorter) {
        switch (sorter.order) {
            case 'ascend':
                return sorter.field + ' asc'
            case 'descend':
                return sorter.field + ' desc'
            default:
                return sorter.field
        }
    }

    async getAll({ current, pageSize }, sorter) {
        try {
            const response = await Http.get(
                `/notification/find_all?offset=${current}&lines=${pageSize}&order=${this.getOrder(sorter)}`, Http.headers);
            return response;
        } catch (e) {
            errorHandling(e)
        }
    }

    async getAllByIds(ids) {
        try {
            const response = await Http.get(`/notification/find_by_ids`, { ids }, Http.headers);
            return response;
        } catch (e) {
            errorHandling(e)
        }
    }

    async search(search, { current, pageSize }, sorter) {
        try {
            let response = await Http.post(
                `/notification/search-notifications`, 
                { search, lines: pageSize, offset: current, order: this.getOrder(sorter) }, 
                Http.headers
            );
            return response;
        } catch (e) {
            errorHandling(e)
        }
    }

    async getById(id) {
        try {
            let response = await Http.get(`/notification/by_id?id=${id}`, Http.headers);
            return response;
        } catch (e) {
            errorHandling(e)
        }
    }

    async insert(data) {
        try {
            let response = await Http.post(`/notification/insert_notification`, data, Http.headers);
            return response;
        } catch (e) {
            errorHandling(e)
        }
    }

    async update(data) {
        try {
            let response = await Http.put(`/notification/update_notification`, data, Http.headers);
            return response;
        } catch (e) {
            errorHandling(e)
        }
    }
}

export default new NotificationService();